// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};


/** Image data-src observer **/
const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const img = entry.target;
            img.srcset = img.getAttribute('data-srcset');
            img.removeAttribute('data-srcset');
            observer.unobserve(img);

        }
    });
});

document.querySelectorAll('img[data-srcset]').forEach(img => {
    observer.observe(img);
});





$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initSlickCarousel();
    app.initDeferredVideos();
    app.scrollToAnchor();
    app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.wrapResponsiveTables();
    app.initMobileMenu();
    app.initRrssb();
    app.initPopups();
    app.initSpotlightJs();
    app.initTingleModalJs();

    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatePicker();
    app.initWowJs();
    app.initStickyEl();
    app.keepTokenAlive();
    //app.initTooltips();
    app.announcementBarDismiss();
    app.equalHeightInner();

    // let googleMaps = require('./modules/google-maps')();
    // googleMaps.assign();


    $(".megamenu").on("click", function (e) {
        e.stopPropagation();
    });

    document.querySelector('.back-to-top').addEventListener('click', () => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reducedMotion ? 'instant' : 'smooth' });
    });

});
